export const staging = 'staging'
export const production = 'production'
export type Env = typeof staging | typeof production
export const isDevelopment = process.env.NODE_ENV === 'development'

export const getEnv = () => {
  if (location.hostname.includes('localhost') || isDevelopment) {
    return staging
  }
  return production
}

export const getEnvDisplay = () => {
  if (getEnv() === production) {
    return undefined
  }
  return 'Staging'
}

export const getMixpanelToken = () => {
  if (getEnv() === staging) {
    return '2db277cb433a23fd1c08f07358cddba6'
  }
  return 'c6d6af0a691272f151e02797d47a644e'
}

export const getApiBaseUrl = () => {
  if (getEnv() === staging) {
    return 'https://c2u39tudz0.execute-api.us-west-2.amazonaws.com/baex/'
  }
  return 'https://c2u39tudz0.execute-api.us-west-2.amazonaws.com/baex/'
}

export const getBaeApiBaseUrl = () => {
  if (getEnv() === staging) {
    return 'https://b.bae.boo'
  }
  return 'https://b.bae.boo'
}

export const getBaeCopeApiBaseUrl = () => {
  if (getEnv() === staging) {
    return 'https://b-cope.bae.boo'
  }
  return 'https://b-cope.bae.boo'
}

export const getWebSocketUrl = () => {
  if (getEnv() === staging) {
    return 'wss://wss.talk2fans.ai/ws'
  }
  return 'wss://wss.talk2fans.ai/ws'
}

const testEmployeeEmails = [
  '408010@tutamail.com',
  'acapprenticewantbemaster@tutamail.com',
  'zation1@gmail.com',
  'xiyuzheng1984@gmail.com',
]

export let isTestEmployee = false

export const onCurrentEmployeeEmailChange = (email: string) => {
  isTestEmployee = testEmployeeEmails.includes(email)
}
